
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.6 7.4H4.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h11.8c.4 0 .7.3.7.7.1.4-.2.7-.6.7zM17.9 12.8H6.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h11.8c.4 0 .7.3.7.7 0 .3-.3.7-.7.7zM19.3 18H7.4c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h11.8c.4 0 .7.3.7.7.1.4-.2.7-.6.7z"}})])
          )
        }
      }
    